export enum CHIP_STYLE {
  SUCCESS = "SUCCESS",
  INACTIVE = "INACTIVE",
  WARNING = "WARNING",
  DANGER = "DANGER",
  INFO = "INFO",
  STARTED = "STARTED",
  BUILDING_DATA = "BUILDING_DATA",
  FETCH_DATA = "FETCH_DATA",
  MERGE_DATA = "MERGE_DATA"
}

export function getChipStyle(style: CHIP_STYLE) {
  switch (style) {
    case CHIP_STYLE.INACTIVE:
      return {
        style: "background-color: rgb(209 209 209); color: rgb(109 109 109);",
        icon: "close",
      };
    case CHIP_STYLE.SUCCESS:
      return {
        style: "background-color: rgb(229 240 230);color: rgb(25 82 33);",
        icon: "check",
      };
    case CHIP_STYLE.DANGER:
      return {
        style: "background-color: #fc0303; color: #FFF;",
        icon: "block",
      };
    case CHIP_STYLE.WARNING:
      return {
        style: "background-color: rgb(255, 240, 204); color: rgb(209, 125, 0);",
        icon: "warning",
      };
    case CHIP_STYLE.INFO:
      return {
        style: "background-color: rgb(148, 224, 255); color: rgb(0, 90, 128);",
        icon: "info",
      };
    case CHIP_STYLE.STARTED:
      return {
        style: "background-color: rgb(255, 240, 204); color: rgb(209, 125, 0);",
        icon: "play_arrow",
      };
    case CHIP_STYLE.FETCH_DATA:
      return {
        style: "background-color: rgb(255, 240, 204); color: rgb(209, 125, 0);",
        icon: "cloud_download",
      };
    case CHIP_STYLE.BUILDING_DATA:
      return {
        style: "background-color: rgb(255, 240, 204); color: rgb(209, 125, 0);",
        icon: "sync",
      };
    case CHIP_STYLE.MERGE_DATA:
      return {
        style: "background-color: rgb(255, 240, 204); color: rgb(209, 125, 0);",
        icon: "merge",
      };
    default:
      return {
        style:
          "background-color: rgb(181 209 183);color: rgb(25 82 33);border-color: rgb(13 174 0);border-style: solid;border-width: thin;",
        icon: "close",
      };
  }
}
